var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33337 4.66667C1.33337 3.19391 2.52728 2 4.00004 2H12C13.4728 2 14.6667 3.19391 14.6667 4.66667V5.66667H12C10.7114 5.66667 9.66671 6.71134 9.66671 8C9.66671 9.28866 10.7114 10.3333 12 10.3333H14.6667V11.3333C14.6667 12.8061 13.4728 14 12 14H4.00004C2.52728 14 1.33337 12.8061 1.33337 11.3333V4.66667ZM12 9.33333L14.6667 9.33333V6.66667H12C11.2637 6.66667 10.6667 7.26362 10.6667 8C10.6667 8.73638 11.2637 9.33333 12 9.33333Z",
    fill: "#009642"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletSolid);
export default __webpack_public_path__ + "static/media/Wallet-Solid.b60826ba.svg";
export { ForwardRef as ReactComponent };